// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__mIsmH","colMin":"styles_colMin__YAl4Z","colCheckbox":"styles_colCheckbox__dDnMT"};